import { render, staticRenderFns } from "./ReportGridForm.vue?vue&type=template&id=8704fb28&scoped=true&"
import script from "./ReportGridForm.vue?vue&type=script&lang=ts&"
export * from "./ReportGridForm.vue?vue&type=script&lang=ts&"
import style0 from "./ReportGridForm.vue?vue&type=style&index=0&id=8704fb28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8704fb28",
  null
  
)

export default component.exports